const RTABLESERVER = '_FFFFFFFFFFFFFF00001713960477110008_';

function endcall(viewport, client, store) {
  /* Create Indexes for Root Menu */
  console.log("Got data for end call: ", client);
  let clientObj = window.botStore.getClientByID(client);
  console.log("Got data for end call: ", clientObj);
  let meetingContext = JSON.parse(clientObj.MeetingContext);
  window.BotServices.callManagerApi({action:'stopCall', data : {ClientID : client,ConferenceID : meetingContext.MeetingId,MeetingParentId:meetingContext.MeetingParentId,MeetingContext: meetingContext,InitialContext : {Caller:{All:true}}}});
  //store.showRibbonIcon(viewport,{"iconId":'startNailup'});
  stopRecording(viewport,client, store);
}

function endParticipant(client,member, store) {
  /* Create Indexes for Root Menu */
  console.log("Got data for end participant: ", client);
  let clientObj = window.botStore.getClientByID(client);
  console.log("Got data for end participant: ", clientObj);
  let meetingContext = JSON.parse(clientObj.MeetingContext);
  window.BotServices.callManagerApi({action:'endParticipant', data : member});
}

function kickOutParticipant(client,member, store) {
  /* Create Indexes for Root Menu */
  console.log("Got data for kickout participant: ", client);
  let clientObj = window.botStore.getClientByID(client);
  console.log("Got data for kickout participant: ", clientObj);
  let meetingContext = JSON.parse(clientObj.MeetingContext);
  window.BotServices.callManagerApi({action:'kickOutParticipant', data : member});
}

function startRecording(viewport,client, store) {
  console.log("start recording",client);
  let clientObj = window.botStore.getClientByID(client);
  console.log("Got data for end call: ", clientObj);
  let meetingContext = JSON.parse(clientObj.MeetingContext);
  meetingContext.event = "RecordingStart";
  let functionName = 'RecordingAPI';
  store.hideRibbonIcon(viewport,{"iconId":'startRecording'});
  store.showRibbonIcon(viewport,{"iconId":'stopRecording'});
  window.BotServices.callManagerApi({action: 'recordingStart', data : meetingContext});
 }

function stopRecording(viewport,client, store) {
  console.log("stop recording");
  let clientObj = window.botStore.getClientByID(client);
  console.log("Got data for end call: ", clientObj);
  let meetingContext = JSON.parse(clientObj.MeetingContext);
  meetingContext.event = "RecordingStop";
  let functionName = 'RecordingAPI';
  store.hideRibbonIcon(viewport,{"iconId":'stopRecording'});
  store.showRibbonIcon(viewport,{"iconId":'startRecording'});
  window.BotServices.callManagerApi({action: 'recordingStop', data : meetingContext});
}

function startNailup(viewport,client, store) {
    console.log("start nailup",client);
    store.hideRibbonIcon(viewport,{"iconId":'startNailup'});
    store.showRibbonIcon(viewport,{"iconId":'stopNailup'});
    
    console.log("==makecall params client===",client);
    let callerAudioFlag = false, callerVideoFlag = false, callerScreenFlag = false;
    let params = {"ClientID":client,"ToPE":null,"mediaType":"Audio"};
    
    if(params.mediaType == "Screen") {
      callerScreenFlag = true;
    } else if(params.mediaType == "Video") {
      callerVideoFlag = true;
    }
    let CallPE = params.ToPE;
    let InitialContext = {Caller:{Audio:callerAudioFlag,NoShow:true,Screen:callerScreenFlag,Video:callerVideoFlag,Pstn:true},Callee:{Audio:true,NoShow:true,Screen:false,Video:false},Calltype:"JOINCALL",Label:"Invite"};
    let callObj = {Mode:"STARTMEDIA" ,ClientID:params.ClientID,DialTimeout:60,CallPE:CallPE,InitialContext:InitialContext,isSignedIn: false};
    window.BotServices.startCall(callObj);

}

function stopNailup(viewport, client, store) {
  console.log("stop nailup");
  store.showRibbonIcon(viewport,{"iconId":'startNailup'});
  store.hideRibbonIcon(viewport,{"iconId":'stopNailup'});
  //window.DevMgr.endcall(viewport,client);
  let callerAudioFlag = false, callerVideoFlag = false, callerScreenFlag = false;
    let params = {"ClientID":client,"ToPE":null,"mediaType":"AudiPso"};
    
    if(params.mediaType == "Screen") {
      callerScreenFlag = true;
    } else if(params.mediaType == "Video") {
      callerVideoFlag = true;
    }
    let CallPE = params.ToPE;
    let InitialContext = {Caller:{Audio:callerAudioFlag,NoShow:true,Screen:callerScreenFlag,Video:callerVideoFlag,Pstn:true},Callee:{Audio:true,NoShow:true,Screen:false,Video:false},Calltype:"JOINCALL",Label:"Invite"};
    let callObj = {Mode:"STARTMEDIA" ,ClientID:params.ClientID,DialTimeout:60,CallPE:CallPE,InitialContext:InitialContext,isSignedIn: false};
    window.BotServices.endCall(callObj);
}

function startMedia(viewport,client,params,store) {
  let callerAudioFlag = true, callerVideoFlag = false, callerScreenFlag = false;
  let mediaparams = {"Event":{"Mode":'MEDIA',ClientID:params.ClientID}};
   console.log("start media got params",params);

  if(params.mediaType != 'Audio') {
    //window.DevMgr.openMediaPlayerWC(mediaparams);
  }
  if(params.mediaType == "Screen") {
    callerScreenFlag = true;
  } else if(params.mediaType == "Video") {
    callerVideoFlag = true;
  } else if(params.mediaType == "Audio") {
    callerAudioFlag = true;
  }
  let CallPE = params.ToPE;
  let InitialContext = {Caller:{Audio:callerAudioFlag,NoShow:true,Screen:callerScreenFlag,Video:callerVideoFlag},Callee:{Audio:true,NoShow:true,Screen:false,Video:false},Calltype:"INVITTECALL",Label:"Invite"};
  let callObj = {Mode:"STARTMEDIA" ,ClientID:params.ClientID,DialTimeout:60,CallPE:CallPE,InitialContext:InitialContext,isSignedIn: false};
  console.log("start media call obj",callObj);
  window.BotServices.startCall(callObj);
}

function startDialer(viewport,client, store) {
  console.log("start dialer");
  store.hideRibbonIcon(viewport,{"iconId":'start_dialer'});
  store.showRibbonIcon(viewport,{"iconId":'stop_dialer'});
}

function stopDialer(viewport,client, store) {
  console.log("stop dialer");
  store.hideRibbonIcon(viewport,{"iconId":'stop_dialer'});
  store.showRibbonIcon(viewport,{"iconId":'start_dialer'});
}

async function ConversationMarketplaceBot(viewport, client, store) {
  console.log("Support Bot");
  let clientObj = window.botStore.getClientByViewPort(viewport);
  let GrantPath = JSON.parse(clientObj.ClientContext);
  let GrantPE = GrantPath.GrantPE;
  let currentContext = JSON.parse(clientObj.CurrentContext);

  let marketplaceMessage = {
    welcomemessage : "Thank you for Connecting with Simplia. Simplia helps you Get Things Done",
    typeofservice : "Would you like to Request a Service or Offer a Service?",
  };
  //window.BotServices.startIvrBot();
  let OpenPE = window.top.oxygenUtil.createSimpleOES(["Provider","_FFFFFFFFFFFFFF00001731965965540235_","Provider","_FFFFFFFFFFFFFF00001731965965540235_"]);
  console.log("set inbox openpe :",OpenPE);              
  await oxygenUtil.callMessageBoxFnWithReturn(viewport,'addRecipientPE',[OpenPE]);
  await window.top.oxygenUtil.callMessageBoxFnWithReturn(viewport,"setupSend",[OpenPE]);
  
  let Params= {};
  Params.EventTemplate = "_FFFFFFFFFFFFFF00001575595750910042_";
  Params.EventRegistrant = "_FFFFFFFFFFFFFF00001575882222359002_";
  Params.Label = "Message";
  Params.NoteTemplateID = "_FFFFFFFFFFFFFF00001633127893643639_";
  Params.ToPE = currentContext.grantItem.GrantPE;
  Params.ByPE = currentContext.grantItem.GrantPE;
//  Params.ByPE = "11Provider%7F1_FFFFFFFFFFFFFF00001731965965540235_%7F1Provider%7F1_FFFFFFFFFFFFFF00001731965965540235_%7F%7F";
  Params.GrantID = currentContext.grantItem.GrantID;
  Params.AttributionID = currentContext.Account.ID;
  Params.RootEventID = "";
  Params.CausingEventID = "";
  window.DevMgr.postToHistory(Params,marketplaceMessage.welcomemessage,(err,result)=>{
    if(result){
       window.DevMgr.postToHistory(Params,marketplaceMessage.typeofservice,()=>{});
    }
  });

}

function showDialpad(viewport, client, store) {
  console.log("show dialpad got");
  let terminationUrl = {"MediaType":"Iframe","URL":"/OxygenDialer/Dialpad/index.html?clientID="+client};
  window.BotServices.openChildPanel({ClientID : client, DisplayName : 'Dialpad', Termination : terminationUrl}, ()=>{});
}

function startMeetingRoom(viewport, client, store) {
  console.log("start meeting got");
  store.hideRibbonIcon(viewport,{"iconId":'StartSimpliaMeet'});
  store.showRibbonIcon(viewport,{"iconId":'StopSimpliaMeet'});

  let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/ReactMediaPlayerV2/index.html?clientID="+client};
  window.BotServices.openChildPanel({ClientID : client, DisplayName : 'Simplia Meet', Termination : terminationUrl}, ()=>{});

}

function stopMeetingRoom(viewport, client, store) {
  store.hideRibbonIcon(viewport,{"iconId":'StopSimpliaMeet'});
  store.showRibbonIcon(viewport,{"iconId":'StartSimpliaMeet'});
  endcall(viewport, client, store);
}

function joinCall(viewport, client, store) {
  console.log("join call clicked",client);
  let clientObj = window.botStore.getClientByID(client);
  console.log("Got data for join call: ", clientObj);
  let meetingContext = JSON.parse(clientObj.MeetingContext);
  window.BotServices.callManagerApi({action:'joinLive', data : {ClientID : client}});
}

function setUserState(viewport, client, store, state) {
  console.log("set user state",state);
  let clientObj = window.botStore.getClientByViewPort(viewport);
  let GrantPath = JSON.parse(clientObj.ClientContext);
  let GrantPE = GrantPath.GrantPE;
  let currentContext = JSON.parse(clientObj.CurrentContext);
  let requestContext = currentContext;
  requestContext.setClientId = clientObj.Client;
  
  if(state == "Available") {
    store.hideRibbonIcon(viewport,{"iconId":'Available'});
    store.showRibbonIcon(viewport,{"iconId":'Busy'});
    requestContext.Availability = 'Busy';
  } else if(state == "Busy") {
    store.showRibbonIcon(viewport,{"iconId":'Available'});
    store.hideRibbonIcon(viewport,{"iconId":'Busy'});
    requestContext.Availability = 'Available';
  }
  
  window.BotServices.commState({Action : 'setRibbonState', Data : requestContext}, (err,res) => {
    console.log("set state result",res);
  });
}

function createHeaderIcons(client,viewport,store) {
  console.log("get state viewportId",viewport);
        let clientObj = window.botStore.getClientByViewPort(viewport);
        let GrantPath = JSON.parse(clientObj.ClientContext);
        let GrantPE = GrantPath.GrantPE;
        let currentContext = JSON.parse(clientObj.CurrentContext);
        let requestContext = currentContext;
        requestContext.setClientId = clientObj.Client;
        
        window.BotServices.commState({Action : 'getRibbonState', Data : requestContext}, (err,res) => {
            console.log("get state result",res);
            let event = res.Availability;
            if(event == "Available") {
              store.hideRibbonIcon(viewport,{"iconId":'Available'});
              store.showRibbonIcon(viewport,{"iconId":'Busy'});
            } else if(event == "Busy") {
              store.hideRibbonIcon(viewport,{"iconId":'Available'});
              store.showRibbonIcon(viewport,{"iconId":'Busy'});
            }
        });

  store.addLeftRibbonIcon(viewport, {iconId:'startNailup', type: 'css', classes: 'far fa-phone-circle',color:"green", callback:(data) => {
    startNailup(viewport,client, store);
  },toolTip:"Start Nailup",show:true});
  store.addLeftRibbonIcon(viewport, {iconId:'stopNailup', type: 'css', classes: 'far fa-phone-circle',color:"red", callback:(data) => {
    stopNailup(viewport,client, store);
  },toolTip:"Stop Nailup",show:false});
  
  store.addLeftRibbonIcon(viewport, { iconId:'StartSimpliaMeet' , type: 'css', classes: 'far fa-video',color:"green", callback:(data) => {
    startMeetingRoom(viewport,client, store, 'Start Meeting');
  },toolTip:"Simplia Meet",show:true});
  
  store.addLeftRibbonIcon(viewport, { iconId:'StopSimpliaMeet' , type: 'css', classes: 'far fa-video',color:"red", callback:(data) => {
    stopMeetingRoom(viewport,client, store, 'End Meeting');
  },toolTip:"End Meet",show:false});
  
  store.addLeftRibbonIcon(viewport, {iconId:'joincall', type: 'css', classes: 'fa-solid fa-tty-answer',color:"green", callback:(data) => {
    joinCall(viewport,client, store);
  },toolTip:"Join Call",show:false});
  
  store.addLeftRibbonIcon(viewport, {client:client,store:store,iconId:'disconnectCall', type: 'css', classes: 'fas fa-phone-slash',color:"red",callback:(data) => {
    endcall(viewport, client, store);
  },toolTip:"Disconnect Call",show:true});
  store.addLeftRibbonIcon(viewport, {iconId:'startRecording', type: 'css', classes: 'far fa-scrubber',color:"green", callback:(data) => {
    startRecording(viewport,client, store);
  },toolTip:"Start Recording",show:true});
  store.addLeftRibbonIcon(viewport, { iconId:'stopRecording' , type: 'css', classes: 'far fa-scrubber',color:"red", callback:(data) => {
    stopRecording(viewport,client, store);
  },toolTip:"Stop Recording",show:false});
  store.addLeftRibbonIcon(viewport, { iconId:'Available' , type: 'css', classes: 'fal fa-globe',color:"green", callback:(data) => {
    setUserState(viewport,client, store, 'Available');
  },toolTip:"Available",show:true});
  store.addLeftRibbonIcon(viewport, { iconId:'Busy' , type: 'css', classes: 'fal fa-globe',color:"red", callback:(data) => {
    setUserState(viewport, client, store, 'Busy');
  },toolTip:"Busy",show:false});
  
  store.addLeftRibbonIcon(viewport, {client:client,store:store,iconId:'dialpadCall', type: 'css', classes: 'far fa-phone-outgoing',color:"green",callback:(data) => {
    showDialpad(viewport, client, store);
  },toolTip:"Dialpad",show:true});
  store.addLeftRibbonIcon(viewport, { iconId:'SupportBot' , type: 'css', classes: 'far fa-robot',color:"#0072C5", callback:(data) => {
    ConversationMarketplaceBot(viewport,client, store);
  },toolTip:"Conversation Marketplace",show:true});
  
  //startRecording(viewport,client, store); 
  /*store.addLeftRibbonIcon(viewport, { iconId:'start_nailup' , type: 'css', classes: 'fal fa-circle-microphone',color:"green", callback:(data) => {
    startNailup(viewport,client, store);
  },toolTip:"Start Nailup",show:true});
  store.addLeftRibbonIcon(viewport, { iconId:'stop_nailup' , type: 'css', classes: 'fal fa-circle-microphone',color:"red", callback:(data) => {
    stopNailup(viewport, client, store);
  },toolTip:"Stop Nailup",show:false});
  store.addLeftRibbonIcon(viewport, { iconId:'start_dialer' , type: 'css', classes: 'fal fa-phone-plus',color:"green", callback:(data) => {
    startDialer(viewport, client, store);
  },toolTip:"Start Dialer",show:true});
  store.addLeftRibbonIcon(viewport, { iconId:'stop_dialer' , type: 'css', classes: 'fas fa-phone-slash',color:"red", callback:(data) => {
    stopDialer(viewport,client, store);
  },toolTip:"Stop Dialer",show:false});*/
  
}

function createRightMenuOptions(client,viewport,store) {
  console.log("Save Meeting option called");
  console.log(" at component client==",client);
  let clientObj = window.botStore.getClientByID(client);
  let currentContext = JSON.parse(clientObj.CurrentContext);
  console.log(" at component==",currentContext.atComponent.InitialContext);
  let MeetingContext = JSON.parse(clientObj.MeetingContext);

  /*store.addRightMemu(viewport,{icon: 'far fa-search', title: 'Search Provider Data', callback: (e)=>{
          console.log("Get search provider form called",e);
          let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/MasterProvider/searchForm.html"};
          window.BotServices.openChildPanel({ClientID : client, DisplayName : 'MasterData', Termination : terminationUrl}, ()=>{});
  }});*/

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Meeting Room', callback: (e)=>{
    console.log("Add oxygen work flow  called",e);
    //let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/ReactMediaPlayerV1/index.html?clientID="+client};
   
    let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/ReactMediaPlayerV2/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Simplia Meet', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Table View', callback: (e)=>{
    console.log("Add R-table spreadsheet called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/WebixODE/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Table View', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Table Charts', callback: (e)=>{
    console.log("Add data graph flow  called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/DevWebstore/ParvBuild/TableCharts/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Table Charts', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Meeting Room V3', callback: (e)=>{
    console.log("Add oxygen work flow  called",e);
    //let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/ReactMediaPlayerV1/index.html?clientID="+client};
   
    let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/LovablePlayer/?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Simplia Meet V3', Termination : terminationUrl}, ()=>{});
  }});


  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Save Json', callback: (e)=>{
    console.log("Add data graph flow  called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/Spreadsheet/save_json.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Save Json', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Form Builder', callback: (e)=>{
    console.log("Add code editor called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/PravNodeJSStarter/formBuilder/index.html?clientId="+clientObj.Client+"&nodeId="+clientObj.ClientRight};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Form Builder', Termination : terminationUrl}, ()=>{});
  }});

  /*store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Data Graph', callback: (e)=>{
    console.log("Add data graph flow  called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/RTableDataGraph/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Data Graph', Termination : terminationUrl}, ()=>{});
  }});*/

 
  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Work Flow', callback: (e)=>{
    console.log("Add oxygen work flow  called",e);
    //let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/OxygenFlows/index.html?clientID="+clientObj.Client};
    let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/BehaviourFlows/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Work-Flow', Termination : terminationUrl}, ()=>{});
  }});


  store.addRightMemu(viewport,{icon: 'far fa-search', title: 'Search Table Data', callback: (e)=>{
    console.log("Get search table provider form called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/ProviderSearch-0026/simple-search-table"};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'MasterData', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Upload CSV', callback: (e)=>{
    console.log("upload csv  called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/ProviderSearch-0026/simple-upload"};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Upload CSV', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Work Flow V1', callback: (e)=>{
    console.log("Add oxygen work flow V1 called",e);
    //let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/OxygenFlows/index.html?clientID="+clientObj.Client};
    let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/BehaviourFlowsV1/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Work-Flow-V1', Termination : terminationUrl}, ()=>{});
  }});

  if(clientObj.ClientRightRole == "admin") {
    store.addRightMemu(viewport,{icon: 'far fa-save-circle-xmark', title: 'Upgrade', callback: (e)=>{
      console.log("upgrade option called",e);
      let UpgradeParams = {
        componentId: RTABLESERVER,
        command: "Upgrade",
        data: { "Context": currentContext ,"TableId" :(currentContext && currentContext.atComponent.MetaType == "Tip") ? currentContext.atComponent.Template : currentContext.atComponent.Node},
        Type: 'BotApi'
      }

      console.log("Upgrade :",UpgradeParams);
      window.top.BotServices.callComponent(UpgradeParams, (err, result) => {
          console.log("Upgrade Got : ", result);
          if(result) {
        
          } else {
            console.log("Upgrade Got error: ", err);
          }
        });
    }});
  }

  store.addRightMemu(viewport,{icon: 'far fa-save-circle-xmark', title: 'Import Table', callback: (e)=>{
    console.log("watch meeting option called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/Spreadsheet/import_table.html"};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Import Table', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-code', title: 'Code Editor', callback: (e)=>{
    console.log("Add code editor called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/DevCodeEditor/index.html?clientId="+clientObj.Client+"&nodeId="+clientObj.ClientRight};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Code Editor', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Test Meeting Room', callback: (e)=>{
    console.log("Add oxygen work flow  called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/ReactMediaPlayerV2/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Test Meeting', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Task Node', callback: (e)=>{
    console.log("Add oxygen task node  called",e);
    
    let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/QuillEditor/QuillEditor.html?clientID="+clientObj.Client};
    //let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/QuillEditor/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Task Node', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Oxygen Dialer V2', callback: (e)=>{
    console.log("Add oxygen dialer v2  called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/OxygenDialer/OxygenDialerV2/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Oxygen Dialer V2', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'System Designer', callback: (e)=>{
    console.log("System Designer option  called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/system-designer/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'System Designer', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'far fa-save-circle-xmark', title: 'Watch', callback: (e)=>{
    console.log("watch meeting option called",e);
    window.DevMgr.openWatchMeetingInfoPopup(client);
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Get Behaviour History', callback: (e)=>{
    console.log("System Designer option  called",e);
      let PostParams = {
        componentId: RTABLESERVER,
        command: "GetBehaviourHistory",
        data: {Context : currentContext},
        Type: 'BotApi'
      }
      console.log("GetBehaviourHistory params : ",PostParams);
      
      window.BotServices.callComponent(PostParams, (err, result) => {
        console.log("GetBehaviourHistory  Got : ", result);
      }); 
  }});
  console.log("===client attribution===",clientObj.Attribution);

  if(clientObj.Attribution == "17981" || clientObj.Attribution == "50260") {
    store.addRightMemu(viewport,{icon: 'far fa-save-circle-xmark', title: 'Init OS Table', callback: (e)=>{
      console.log("open open search table called",e);
      let PostParams = {
        componentId: RTABLESERVER,
        command: "InitOpenSerachTable",
        data: {Context : currentContext},
        Type: 'BotApi'
      }
      console.log("InitOpenSerachTable params : ",PostParams);
      
      window.BotServices.callComponent(PostParams, (err, result) => {
        console.log("InitOpenSerachTable  Got : ", result);
      }); 
    }});

    store.addRightMemu(viewport,{icon: 'far fa-save-circle-xmark', title: 'Rule Grant', callback: (e)=>{
      console.log("open open search table called",e);
      let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/Spreadsheet/rule_grant.html"};
      window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Rule Grant', Termination : terminationUrl}, ()=>{});
  
    }});

    store.addRightMemu(viewport,{icon: 'far fa-save-circle-xmark', title: 'Fixed Column', callback: (e)=>{
      console.log("open open search table called",e);
      let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/Spreadsheet/fixed_column.html"};
      window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Fixed Column', Termination : terminationUrl}, ()=>{});
  
    }});

    
  }
  /*store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Media Player', callback: (e)=>{
    console.log("Add oxygen work flow  called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/ReactMediaPlayer/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'MediaPlayer', Termination : terminationUrl}, ()=>{});
  }});*/

  /*store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Add Rules', callback: (e)=>{
    console.log("Add Desk Link called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/Rules/Rules.html"};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Rules', Termination : terminationUrl}, ()=>{});
  }});*/

  store.addRightMemu(viewport,{icon: 'fal fa-gears', title: 'Dev Options', callback: (e)=>{
    console.log("Dev Options icon called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/WebServices/"};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Dev Options', Termination : terminationUrl}, ()=>{});
  }});

  /*store.addRightMemu(viewport,{icon: 'fal fa-gears', title: 'Dev Commands', callback: (e)=>{
    console.log("Dev Commands icon called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/DevCommands/devCommands.html?clientID="+client};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Dev Commands', Termination : terminationUrl}, ()=>{});
  }});*/

  store.addRightMemu(viewport,{icon: 'fal fa-gears', title: 'Desk Settings', callback: (e)=>{
    console.log("desk settings called",e);
    //window.DevMgr.openSimpliaPublishingPopup(client,viewport,store);
    let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/Publishing/simpliaDesk.html?clientID="+client};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Desk Settings', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'far fa-user-group', title: 'Simplia Publishing', callback: (e)=>{
    console.log("Simplia Publishing called",e);
    //window.DevMgr.openSimpliaPublishingPopup(client,viewport,store);
    let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/Publishing/PublishingV1.html?clientID="+client};
    //let terminationUrl = {"MediaType":"Iframe","URL":"/DevWebstore/AmanKumar/SimpliaPublishing/Publishing.html?clientID="+client};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Publishing Link', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-gears', title: 'Alias Settings', callback: (e)=>{
    console.log("New Settings icon called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/ForwardSettings/alias_settings.html?clientID="+client};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Alias Settings', Termination : terminationUrl}, ()=>{});
  }});

  
  store.addRightMemu(viewport,{icon: 'fal fa-gears', title: 'Phone Settings', callback: (e)=>{
    console.log("New Settings icon called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/ForwardSettings/ForwardSettings.html?clientID="+client};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Phone Settings', Termination : terminationUrl}, ()=>{});
  }});

  /*store.addRightMemu(viewport,{icon: 'far fa-user-group', title: 'Meeting Links', callback: (e)=>{
    console.log("Meeting Link called",e);
    window.DevMgr.openMeetingLinksPopup(client,viewport,store);
  }});*/


  store.addRightMemu(viewport,{icon: 'far fa-user-group', title: 'Attribution', callback: (e)=>{
    console.log("Meeting Link called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/Attribution/Attribution.html"};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Attribution', Termination : terminationUrl}, ()=>{});

  }});

  store.addRightMemu(viewport,{icon: 'far fa-pencil-paintbrush', title: 'Whiteboard', callback: (e)=>{
    console.log("Whiteboard called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/WhiteBoard-0052/tldraw/index.html?meetingId="+MeetingContext.MeetingParentId};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Whiteboard', Termination : terminationUrl, "Template":"oxygen-whiteboard",CssLink:"/WhiteBoard-0052/tldraw/static/css/main.e6c13ad2.css"}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'far fa-user-group', title: 'Create DeepLink', callback: (e)=>{
    console.log("Save Meeting option called",e);
    window.DevMgr.openDeepLinkPopup(client,viewport,store);
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Kanban View', callback: (e)=>{
    console.log("Add kanban view  called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/PinkiKNode/testBoard/index.html?clientID="+clientObj.Client};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Kanban View', Termination : terminationUrl}, ()=>{});
  }});

  /*store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Test Page', callback: (e)=>{
    console.log("Add oxygen work flow  called",e);
    let terminationUrl = {"MediaType":"WebComponent",Template : 'oxygen-mediaplayer',"URL":"/CommunicationClient/wcdist/src/CommMediaPlayer.js"};
    window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'MediaPlayer', Termination : terminationUrl}, ()=>{});
  }});
  https://debianlargeserver-0050-kamalk-0054.laxroute53.com/ProviderSearch-0026/simple-search
  */

  store.addRightMemu(viewport,{icon: 'far fa-search', title: 'Search Provider Data', callback: (e)=>{
    console.log("Get search provider form called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"/ProviderSearch-0026/simple-search"};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'MasterData', Termination : terminationUrl}, ()=>{});
  }});

  if(clientObj.ClientRightRole == "admin") {
    store.addRightMemu(viewport,{icon: 'fal fa-cloud', title: 'Behaviours', callback: (e)=>{
      console.log("Get Behaviours called",e);
      let terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/Behaviours/Behaviour.html"};
      window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Behaviours', Termination : terminationUrl}, ()=>{});
    }});
  }

  store.addRightMemu(viewport,{icon: 'fal fa-table', title: 'Followup', callback: (e)=>{
        console.log(" Tracking option called",e);
        window.DevMgr.openDeskListPopup({viewport});
  }});

  store.addRightMemu(viewport,{icon: 'fal fa-upload', title: 'Import Table', callback: (e)=>{
        console.log(" Import Table option called",e);
        window.DevMgr.openImportTablePopup({viewport});
  }});

  /*store.addRightMemu(viewport,{icon: 'far fa-phone-intercom', title: 'Set Phone Number', callback: (e)=>{
        console.log("Set phone number option called",e);
        window.DevMgr.openSetPhoneNumberPopup(client,viewport,store);
  }});*/
  store.addRightMemu(viewport,{icon: 'fal fa-at', title: 'Set Email Address', callback: (e)=>{
        console.log("Set email address option called",e);
        window.DevMgr.openSetEmailAddressPopup(client,viewport,store);
  }});
  store.addRightMemu(viewport,{icon: 'far fa-cloud-plus', title: 'Set Oxygen Number', callback: (e)=>{
        console.log("Save oxygen number option called",e);
        window.DevMgr.openSetOxygenNumberPopup(client,viewport,store);
  }});

  if(clientObj.MeetingRole == "Moderator") {
    store.addRightMemu(viewport,{icon: 'far fa-user-group', title: 'Save Meeting', callback: (e)=>{
          console.log("Save Meeting option called",e);
          window.DevMgr.openSaveMeetingPopup(client,viewport,store);
         //let terminationUrl = {"MediaType":"Iframe","URL":"https://debianlargeserver-0050-developer.laxroute53.com/GourangaMNode/savemeetinggm/index.html"};
         //window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Save Meeting', Termination : terminationUrl}, ()=>{});     
    }});
  }
  store.addRightMemu(viewport,{icon: 'far fa-save-circle-xmark', title: 'Meeting Info', callback: (e)=>{
        console.log("Save Meeting option called",e);
        window.DevMgr.openMeetingInfoPopup(client);
  }});

  store.addRightMemu(viewport,{icon: 'far fa-robot', title: 'Chat Bot', callback: (e)=>{
    console.log("Get marketplace chat bot called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"https://debianlargeserver-0050-developer.laxroute53.com/GugulothSNode/sumanTest2/"};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Marketplace Chat Bot', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'far fa-robot', title: 'LCM Servers', callback: (e)=>{
    console.log("Get LCM server called",e);
    //let url = "https://debianlargeserver-0050-developer.laxroute53.com/GourangaMNode/serverManagementSystem/";
    let url="https://debianlargeserver-0050-developer.laxroute53.com/AmanKNode/lcmServersTS/";
    let terminationUrl = {"MediaType":"Iframe","URL":url};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'LCM', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'far fa-robot', title: 'Navigator', callback: (e)=>{
    console.log("Get navigator called",e);
    let url = "/DeepLander-0086/CRMV2/Navigator/Navigator.html?clientID="+client;
    let terminationUrl = {"MediaType":"Iframe","URL":url};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Navigator', Termination : terminationUrl}, ()=>{});
  }});
  
  store.addRightMemu(viewport,{icon: 'far fa-robot', title: 'Table Templates', callback: (e)=>{
    console.log("Get table template called",e);
    window.DevMgr.getTableTemplates(client, (err, data) => {
      console.log('CRM TEMPLATES', err, data)
      //this.crmTemplates = data
    })
  }});

  /*store.addRightMemu(viewport,{icon: 'far fa-robot', title: 'Test Settings', callback: (e)=>{
    console.log("Get test settings called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"https://debianlargeserver-0050-developer.laxroute53.com/PinkiKNode/pinkiTest/"};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Test Settings', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'far fa-robot', title: 'Test Tracker', callback: (e)=>{
    console.log("Get test tracker called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"https://debianlargeserver-0050-developer.laxroute53.com/PinkiKNode/issueTracker/"};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Test Tracker', Termination : terminationUrl}, ()=>{});
  }});

  store.addRightMemu(viewport,{icon: 'far fa-robot', title: 'Test Dialer', callback: (e)=>{
    console.log("Get test dialer called",e);
    let terminationUrl = {"MediaType":"Iframe","URL":"https://debianlargeserver-0050-developer.laxroute53.com/ChiragKNode/chiragReactFlow/"};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Test Dialer', Termination : terminationUrl}, ()=>{});
  }});
  
  store.addRightMemu(viewport,{icon: 'far fa-robot', title: 'Test Number', callback: (e)=>{
    console.log("Get test dialer called",e);
    //let url = "https://debianlargeserver-0050-developer.laxroute53.com/AmanKNode/amanSimpliaPublishingReact/";
    let url = "https://debianlargeserver-0050-developer.laxroute53.com/AmanKNode/Publishing.html?clientID="+client;
    //let url = "https://debianlargeserver-0050-developer.laxroute53.com/AmanKNode/SimpliaNumberInventory/NumberInventory.html?clientID="+client;
    let terminationUrl = {"MediaType":"Iframe","URL":url};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Number', Termination : terminationUrl}, ()=>{});
  }});
  */
  if(clientObj.ClientRightRole == "developer") {
    store.addRightMemu(viewport,{icon: 'far fa-user-group', title: 'Show Context', callback: (e)=>{
          console.log("Show context option called",e);
          window.DevMgr.openShowContextPopup(client,viewport,store);
    }});
  }
  /*
  store.addRightMemu(viewport,{icon: 'far fa-user-group', title: 'test Save ', callback: (e)=>{
    console.log("Save Meeting option called",e);
    //window.DevMgr.openSaveMeetingPopup(client,viewport,store);
    let terminationUrl = {"MediaType":"Iframe","URL":"https://debianlargeserver-0050-developer.laxroute53.com/GourangaMNode/savemeetinggm/index.html"};
    window.top.BotServices.openChildPanel({ClientID : client, DisplayName : 'Save Meeting', Termination : terminationUrl}, ()=>{});     
  }});
*/
    let InitialContext = currentContext.atComponent.InitialContext;
    if(InitialContext && InitialContext.ChildTerminations && InitialContext.ChildTerminations.length > 0) {

    InitialContext.ChildTerminations.forEach((child) => {
      store.addRightMemu(viewport,{icon: 'fal fa-save', title: child.DisplayName, callback : (e)=>{
            console.log("child termination called",e,child);
            let parentIndex = store.getMeetingIndex(clientObj.RootMeeting);
            let localIndex = store.getMeetingIndex(clientObj.Meeting);

            let rootMenuObj = {
              ParentIndex : localIndex,
              LocalIndex : localIndex,
              PrettyURL : null,
              Path : clientObj.RootMeeting+'/'+ child.DisplayName,
              LeftRole : clientObj.ClientLeftRole,
              RightRole : clientObj.ClientRightRole,
              LeftID : clientObj.ClientLeft,
              RightID : clientObj.ClientRight,
              LeftDN : clientObj.ClientRightDN,
              RightDN : child.DisplayName,
              DisplayStatus : null,
              ClientRowID : clientObj.Client
            };

            store.addRootMenu(rootMenuObj);
            console.log("PullRootMenu currentContext : ", currentContext);
            rootMenuObj.Termination = child;
            window.BotServices.PullRootMenu(rootMenuObj);
      }});
    });

    }

    /*store.addRightMemu(viewport,{icon: 'far fa-filter', title: 'Forward Settings', callback: (e)=>{
          console.log("Forward Meeting option called",e);
          window.DevMgr.openForwardSettingsPopup({});
    }});*/

  /*  store.addRightMemu(viewport,{icon: 'fal fa-save', title: 'Tracking', callback: (e)=>{
          console.log(" Tracking option called",e);
          window.DevMgr.openDeskListPopup({viewport});

          let parentIndex = store.getMeetingIndex(clientObj.RootMeeting);
          let localIndex = store.getMeetingIndex(clientObj.Meeting);

          let rootMenuObj = {
            ParentIndex : localIndex,
            LocalIndex : localIndex,
            PrettyURL : null,
            Path : clientObj.RootMeeting+'/Desk',
            LeftRole : clientObj.ClientLeftRole,
            RightRole : clientObj.ClientRightRole,
            LeftID : clientObj.ClientLeft,
            RightID : clientObj.ClientRight,
            LeftDN : clientObj.ClientRightDN,
            RightDN : 'Desk',
            DisplayStatus : null,
            ClientRowID : clientObj.Client
          };

          store.addRootMenu(rootMenuObj);
          console.log("PullRootMenu currentContext : ", currentContext);
          if(clientObj.ClientRight == '_FFFFFFFFFFFFFF00001665780556359109_') {
             rootMenuObj.Termination = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/LetoCRM/home.html"};
          } else
          {
              rootMenuObj.Termination = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/Desk/Desk.html"};
          }
          window.BotServices.PullRootMenu(rootMenuObj);
    }});*/

}

function setMeeting() {
  console.log("set meeting");
}

function btnAlerttest() {
  console.log("btn alert test");
}

export {
  endcall,
  startRecording,
  stopRecording,
  startNailup,
  stopNailup,
  createHeaderIcons,
  createRightMenuOptions,
  setMeeting,
  startMedia,
  endParticipant,
  kickOutParticipant
}
